import { WEB_COMPONENT_WEB_ACCESS_CONTROL_CUSTOM_PAGES_FORM } from '../../webcomponents.constants';
import { WebAccessControlCustomPagesFormComponent } from './component/WebAccessControlCustomPagesFormComponent';

export { WebAccessControlCustomPagesFormComponent };

window.customElements.define(WEB_COMPONENT_WEB_ACCESS_CONTROL_CUSTOM_PAGES_FORM, WebAccessControlCustomPagesFormComponent);
